<template>
    <ul class="subscription-levels">
        <li v-for="level in $store.getters.sponsorshipLevels" :key="level.ID">
            {{level.name}}&nbsp;&mdash; <span class="orange">{{level.price}}&nbsp;{{level.currency}}</span>/{{$t('periods.' + level.paymentPeriod)}}
            <ul class="effect-grants">
                <li v-for="grant in level.grants" :key="grant.class_id">{{grant.class_name}}&nbsp;&mdash; <span class="orange">{{grant.limit}}</span> {{ $t(`sponsor.per_${grant.period}`) }}</li>
            </ul>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'SubscriptionLevels'
};
</script>
<style lang="scss">
.subscription-levels {
    margin: 10px 0 20px 0;
    padding-left: 20px;
    & > li {
        margin-top: 10px;
    }
    ul {
        padding-left: 20px;
    }
}
</style>
